
function getQueryNames(prefix: string) {
	return {
		one: prefix + '_one',
		many: prefix + '_many',
		// count: prefix + '_count',
		create: prefix + '_one_create',
		update: prefix + '_one_update',
		delete: prefix + '_one_delete'
	};
}

export default {
	ARTICLE: getQueryNames('article'),
	CATEGORY: getQueryNames('kbCategory'),
	KB: getQueryNames('knowledgeBase'),
	ARTICLE_CONTRIBUTOR: getQueryNames('articleContributor'),
	GLOSSARY_TERM: getQueryNames('glossaryTerm'),
	ATTACHMENT: getQueryNames('kbAttachment'),
	CONTENT_BLOCK: getQueryNames('kbContentBlock'),
	CONTRIBUTOR: {
		one: 'contributor',
		many: 'contributors'
	},
	PRODUCTCONTRIBUTOR: {
		one: 'productContributor',
		many: 'productContributors'
	},
	TAGS: {
		one: 'tag',
		many: 'tags'
	}
};



// WEBPACK FOOTER //
// ./src/panels/kb/entityMeta.ts